var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('InputTaoSir',{attrs:{"_value":_vm._value,"propertie":_vm.propertie,"tipRule":_vm.tipRule},on:{"change":_vm.change}})}
var staticRenderFns = []

export { render, staticRenderFns }